<template>
    <span>
        <span v-if="options.length === 1">
            {{this.options[0]}}
        </span>
        <span v-else>
            <select @input="handleOptionSelected" :value="selected">
                <option v-for="(option, idx) in options" :key="idx" :value="idx">{{option}}</option>
            </select>
        </span>
    </span>
</template>

<script>
export default {
    name: 'DropdownSelector',
    props: {
        index: Number,
        selected: Number,
        options: Array
    },
    methods: {
        handleOptionSelected (e) {
            this.$emit('optionSelected', this.index, e.target.value);
        }
    }
};
</script>

<style scoped>

</style>
